import { useEffect, useState } from "react";
import Moment from "react-moment";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import {
  resetSearchedOffices,
  resetStatus,
  searchOffices,
} from "../../../redux/slice/office/officeSlice";
import PaginationLinks from "../../pagination/PaginationLinks";
import { fetchAllOffices } from "./../../../redux/slice/office/officeSlice";
import { BounceLoader } from "react-spinners";

const OfficeTable = () => {
  const [filterBy, setFilterBy] = useState();
  const [pageNumber, setPageNumber] = useState(1);
  const [createOffice, setCreateOffice] = useState();
  const [viewOffice, setViewOffice] = useState();
  const { user } = useSelector((state) => state.auth?.user);
  const { user_permissions } = useSelector((state) => state.auth?.user);
  const { offices, isSuccess, searchLoading, searchedOffices } = useSelector(
    (state) => state.office
  );
  const [paginatedOffices, setPaginatedOffices] = useState(offices?.paginated);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const fetchOfficeHandler = async (pageNum) => {
    setPageNumber(pageNum);
    dispatch(
      fetchAllOffices({ office_id: user?.office_id, pageNumber: pageNum })
    );
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (filterBy?.length) {
      const payload = {
        office_id: user?.office_id,
        searchText: filterBy,
      };
      dispatch(searchOffices(payload));
    }
  };

  useEffect(() => {
    fetchOfficeHandler(pageNumber);
  }, []);

  useEffect(() => {
    if (isSuccess) {
      dispatch(resetStatus());
    }
  }, [isSuccess]);
  useEffect(() => {
    navigate({
      pathname: "/admin/office-list",
      search: `?page=${pageNumber}`,
    });
  }, [offices]);

  useEffect(() => {
    if (searchedOffices) {
      setPaginatedOffices(searchedOffices);
    }
    if (!filterBy) {
      setPaginatedOffices(offices?.paginated);
      dispatch(resetSearchedOffices());
    }
  }, [searchedOffices, filterBy, offices?.paginated, dispatch]);

  useEffect(() => {
    setCreateOffice(
      user_permissions?.some(
        (permission) => permission.name === "create office"
      )
    );
    setViewOffice(
      user_permissions?.some((permission) => permission.name === "view office")
    );
  }, [navigate, user_permissions]);

  if (offices.length === 0) {
    return (
      <h2>
        <BeatLoader />
      </h2>
    );
  }

  return (
    <>
      {/* Table row */}
      <div className='row'>
        <div className='col-12'>
          <div className='card'>
            <div className='card-body'>
              <div className='row border-bottom mb-3 pb-2'>
                <div
                  className={`col-md-12 d-flex ${
                    createOffice
                      ? "justify-content-between"
                      : "justify-content-end"
                  } align-items-center`}
                >
                  {createOffice && (
                    <Link
                      to='/admin/add-office'
                      className='btn btn-primary float-end '
                    >
                      Add New Office
                    </Link>
                  )}
                  <form
                    onSubmit={handleSearch}
                    className='d-flex bg-primary-1 align-items-center '
                    style={{ height: "30px", width: "217px" }}
                  >
                    <input
                      type='search'
                      value={filterBy}
                      className='border-0'
                      placeholder='Search...'
                      onChange={(e) => setFilterBy(e.target.value)}
                      style={{
                        height: "28px",
                        marginLeft: "1px",
                        outline: "none",
                      }}
                    />
                    <button
                      type='submit'
                      className='btn btn-primary btn-sm d-flex align-items-center gap-1'
                      style={{ height: "28px" }}
                      disabled={!filterBy}
                    >
                      <i className='uil uil-search text-white fs-4'></i>
                    </button>
                  </form>
                </div>
              </div>
              {/* <div className="clear-fix"></div> */}

              {!offices ? (
                <div className='alert alert-info rounded-0 p-3'>
                  No Record Found
                </div>
              ) : (
                <div>
                  <div className='table-responsive'>
                    <div
                      id='products-datatable_wrapper'
                      className='dataTables_wrapper dt-bootstrap5 no-footer'
                    >
                      <div className='row'>
                        <div className='col-sm-6'>
                          {/* <div className="dataTables_length" id="products-datatable_length">
                                    <label className="form-label">
                                        Display
                                        <select className="form-select form-select-sm ms-1 me-1">
                                            <option value="10">10</option>
                                            <option value="20">20</option>
                                            <option value="-1">All</option>
                                        </select>
                                        offices
                                    </label>
                                </div> */}
                        </div>
                        {/* <div className="col-sm-6">
                                <div id="products-datatable_filter" className="dataTables_filter">
                                    <label>Search:<input type="search" className="form-control form-control-sm" placeholder="" aria-controls="products-datatable" /></label>
                                </div>
                            </div> */}
                      </div>

                      <div className='row'>
                        <div className='col-sm-12 position-relative'>
                          <table
                            className='table table-centered table-striped dt-responsive nowrap w-100 dataTable no-footer dtr-inline collapsed'
                            id='tableDataset'
                            aria-describedby='products-datatable_info'
                          >
                            <thead>
                              <tr>
                                <th
                                  style={{ width: "27.6px" }}
                                  className='sorting_disabled dt-checkboxes-cell dt-checkboxes-select-all'
                                  rowSpan='1'
                                  colSpan='1'
                                >
                                  #
                                </th>
                                {/* <th className="sorting" tabIndex="0" aria-controls="products-datatable" rowSpan="1" colSpan="1"  style={{width: '114.8px'}} aria-label="Phone: activate to sort column ascending">Parent Office</th> */}
                                <th
                                  className='sorting'
                                  tabIndex='0'
                                  aria-controls='products-datatable'
                                  rowSpan='1'
                                  colSpan='1'
                                  style={{ width: "117.8px" }}
                                  aria-label='Email: activate to sort column ascending'
                                >
                                  Office Name
                                </th>
                                <th
                                  className='sorting'
                                  tabIndex='0'
                                  aria-controls='products-datatable'
                                  rowSpan='1'
                                  colSpan='1'
                                  style={{ width: "106.8px" }}
                                  aria-label='Location: activate to sort column ascending'
                                >
                                  Location
                                </th>
                                <th
                                  className='sorting sorting_asc'
                                  tabIndex='0'
                                  aria-controls='products-datatable'
                                  rowSpan='1'
                                  colSpan='1'
                                  style={{ width: "96.8px" }}
                                >
                                  Address
                                </th>
                                <th
                                  style={{ width: "75.6px" }}
                                  className='dt-body-right sorting_disabled'
                                  rowSpan='1'
                                  colSpan='1'
                                >
                                  Date Registered
                                </th>
                                {viewOffice && (
                                  <th
                                    className='sorting'
                                    tabIndex='0'
                                    aria-controls='products-datatable'
                                    rowSpan='1'
                                    colSpan='1'
                                    style={{ width: "55.8px" }}
                                    aria-label='Status: activate to sort column ascending'
                                  >
                                    Action
                                  </th>
                                )}
                              </tr>
                            </thead>

                            <tbody>
                              {paginatedOffices?.data.map((office, index) => (
                                <tr key={office.office_name}>
                                  <td>{index + 1}</td>
                                  <td>{office.office_name}</td>
                                  <td>{office.location}</td>
                                  <td>
                                    {office.office_address
                                      .slice(0, 20)
                                      .concat("...")}
                                  </td>
                                  <td>
                                    <Moment
                                      format='DD-MM-YYYY'
                                      date={office.created_at}
                                    />
                                  </td>
                                  {viewOffice && (
                                    <td>
                                      <Link
                                        to={`/admin/office-details/${office.id}`}
                                        className='action-icon text-primary'
                                      >
                                        {" "}
                                        <i className='mdi mdi-eye'></i>
                                      </Link>
                                    </td>
                                  )}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Pagination */}
                  <div className='row'>
                    <div className='col-sm-12 col-md-6'>
                      <div
                        className='dataTables_info table-pages'
                        id='products-datatable_info'
                        role='status'
                        aria-live='polite'
                      >
                        Showing offices {paginatedOffices?.from} to{" "}
                        {paginatedOffices?.to} of {paginatedOffices?.total}
                      </div>
                    </div>
                    <div className='col-sm-12 col-md-6'>
                      <PaginationLinks
                        paginationData={paginatedOffices}
                        getNextPage={fetchOfficeHandler}
                      />
                    </div>
                  </div>
                  {searchLoading && (
                    <div
                      className='position-absolute top-0 start-0 end-0 bottom d-flex justify-content-center align-items-center transparent-primary z-1000 '
                      style={{ height: "100%" }}
                    >
                      <div className='mx-auto'>
                        <BounceLoader
                          color='#090b8f'
                          loading={true}
                          // cssOverride={override}
                          size={50}
                          aria-label='Loading Spinner'
                          data-testid='loader'
                          className='ms-3'
                        />
                        <span className='fw-bolder text-primary-1 ms-2'>
                          Please wait...
                        </span>
                      </div>
                    </div>
                  )}
                  {/* End Pagination */}
                </div>
              )}
            </div>
            {/* <!-- end card-body--> */}
          </div>
          {/* <!-- end card--> */}
        </div>
      </div>
      {/*  End table row */}
    </>
  );
};

export default OfficeTable;
